import sidebar from './parts/league/round/race/sidebar'

(() => {
  sidebar();
})();
